import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cakeStoreBrands, cakeStoreStoresV2, cakeStoreGoodsV2, exportCakeStoreData, exportCakeStoreZYDData, exportCakeStoreStoresV2, exportCakeStoreGoodsV2, getCakeStoreCategory, cakeStoreSyncCustomerList } from '@/api/order';
import { getStoreCitys, getCakeStoreBrandsList as _getCakeStoreBrandsList, getGoodsDetail } from '@/api/goodsCenter';
import { isNumber } from '@/utils';
export default {
  name: 'cakeStoreConfig',
  props: {
    defaultTab: {
      type: String,
      default: ''
    },
    order_id: [Number, String],
    currentRowMenu: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    ruleType: String,
    /**
     * @description menuType 菜单类型
     * orderDetails - 订单列表-订单详情-订单规则
     * channelCardTypeManage - 管理中心 卡类型管理
     * saleCardTypeManage - 销售工具 卡类型管理
     * customerSet - 客户管理 - 客户列表 - 设置 - 营销参数管理
     */
    menuType: String,
    cakeStoreType: String,
    // view - 查看 没有编辑功能  set - 允许编辑
    ruleInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menusInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hasEditRule: Boolean
  },
  data: function data() {
    return {
      activeTab: 'cake_store',
      originalForm: {},
      profitForm: {
        ratio: 0
      },
      rules: {
        ratio: [{
          required: true,
          pattern: /^(([+-])?([0-9]+(\.[0-9]{1,2})?))$/,
          message: '请填写数字格式，仅限两位小数',
          trigger: 'change'
        }]
      },
      unmetTotal: 0,
      disableProfit: true,
      menuTotal: 0,
      // 菜单级规则 可用品牌数

      blackBrandTotal: 0,
      // 订单级黑名单品牌总数
      action: -1,
      // 未设置=-1 | 黑名单=0 | 白名单=1

      activeBrand: 'not_allow_brand',
      citys: [],
      categoryList: [],
      searchForm: {
        region_id: '',
        category_id: [],
        brand_name: '',
        min_ratio: '',
        max_ratio: '',
        page: 1,
        pagesize: 20
      },
      totalCount: 0,
      tableData: [],
      // 蛋糕到店 可用门店/可用商品 tab start 仅 cake_store 模式下展示
      activeName: '0',
      // 0-可用品牌 1-可用门店 2-可用商品
      brandList: [],
      storeForm: {
        region_id: '',
        category_id: [],
        brand_id: '',
        store_name: '',
        goods_id: '',
        page: 1,
        pagesize: 20
      },
      storeTotal: 0,
      storeList: [],
      exportStoreLoading: false,
      goodsForm: {
        region_id: '',
        goods_id: '',
        name: '',
        category_id: [],
        brand_id: '',
        store_id: '',
        profit_ratio_gt: '',
        // 折扣最低
        profit_ratio_lt: '',
        // 折扣最高
        min_buy_limit: '',
        max_buy_limit: '',
        page: 1,
        pagesize: 20
      },
      goodsTotal: 0,
      goodsList: [],
      exportGoodsLoading: false,
      buyLimitList: [{
        name: '全部',
        value: ''
      }, {
        name: '平台级',
        value: '0'
      }, {
        name: '渠道级',
        value: '1'
      }],
      goodsDetailDialog: false,
      goodsInfo: {
        butNote: []
      },
      // 蛋糕到店 可用门店/可用商品 tab end
      // allowTotal: 0,
      checkAll: false,
      // city tree dialog start
      showCityDialog: false,
      cityList: [],
      filterText: '',
      // city tree dialog end

      // 不满足利润率品牌明细dialog start
      detailDialog: false,
      dialogForm: {
        region_id: '',
        category_id: [],
        brand_name: '',
        min_ratio: '',
        max_ratio: '',
        page: 1,
        pagesize: 20
      },
      dialogAction: -1,
      dialogTotalCount: 0,
      dialogTableData: [],
      syncLoading: false,
      allow_brand_total: 0,
      // 可选品牌库品牌总数
      not_allow_brand_total: 0,
      // 黑名单/白名单总数
      route_type: '',
      // 0通用规则 1订单规则 为0时 自由兑同步客户级黑名单时 需要先调用一下大保存转换为订单规则
      // 不满足利润率品牌明细dialog end
      exportLoading: false,
      // 客户级利润率表单 start
      profitCustomerForm: {
        unmetTotal: 0,
        rate_control: '',
        ratio: '',
        account_id: ''
      },
      // 客户级利润率表单 end

      dialogType: 'normal' // normal - 不满足利润率品牌明细dialog  menus - 菜单级规则品牌明细dialog  customer - 客户级黑名单品牌明细dialog  viewBlack - 查看订单级黑名单  setBlack - 设置订单级黑名单
    };
  },
  methods: {
    syncCustomerList: function syncCustomerList() {
      var _this = this;
      var cb = function cb() {
        _this.syncLoading = true;
        cakeStoreSyncCustomerList({
          order_id: _this.order_id,
          menu_id: _this.currentRowMenu.id,
          account_id: _this.profitCustomerForm.account_id,
          cake_store_zyd_action: _this.dialogAction
        }).then(function (_) {
          _this.$message.success('同步成功');
          _this.viewDetail({
            loadTotal: true
          });
          _this.getList({
            type: 'allow_brand'
          }, true);
          _this.getBlackTotal(); // 订单级黑名单品牌数
        }).finally(function () {
          _this.syncLoading = false;
        });
      };
      if (this.route_type === 0) {
        // 为0时 需要先调用一下大保存转换为订单规则
        this.$emit('_syncCustomerList', {
          cb: cb
        });
      } else {
        cb();
      }
    },
    changeAction: function changeAction() {
      var _this2 = this;
      this.activeBrand = 'not_allow_brand';
      this.$nextTick(function () {
        _this2.dialogSearch(1, {
          type: 'reset',
          loadTotal: true
        });
      });
    },
    openDialog: function openDialog(dialogType) {
      if (dialogType === 'normal' && this.activeTab === 'cake_store') {
        var profit_ratio_gt = (100 - this.profitForm.ratio) / 10;
        var src = "".concat(this.$store.state.user.domainName, "/#/goodsCenter/cakeToStore?activeName=goods&profit_ratio_gt=").concat(profit_ratio_gt.toFixed(2));
        window.open(src, '_blank');
        return;
      }
      this.activeBrand = 'not_allow_brand';
      this.dialogType = dialogType;
      this.dialogAction = this.activeTab === 'cake_store_zyd' && ['viewBlack', 'setBlack'].includes(dialogType) ? this.action : 0;
      if (this.activeTab === 'cake_store_zyd' && ![0, 1].includes(this.dialogAction)) {
        // 蛋糕自由兑 未设置黑 / 白名单时 不请求数据，打开弹窗先选择要设置的类型
        this.detailDialog = true;
        return;
      }
      this.dialogSearch(1, {
        type: 'reset',
        loadTotal: true
      });
    },
    sizeChange: function sizeChange(formName, size) {
      this[formName].pagesize = size;
      if (formName === 'searchForm') {
        this.pageChange(1);
      } else if (formName === 'dialogForm') {
        this.dialogSearch(1);
      }
    },
    exportData: function exportData() {
      var _this3 = this;
      this.exportLoading = true;
      var req = exportCakeStoreData;
      if (this.activeTab === 'cake_store_zyd') {
        req = exportCakeStoreZYDData;
      }
      req(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.ruleType === 'cardType' ? {
        rule_id: this.ruleInfo.id
      } : {
        order_id: this.order_id
      }), this.searchForm), this.profitForm), {}, {
        type: 'allow_brand',
        menu_id: this.currentRowMenu.id
      }), this.menuType).then(function (_) {
        _this3.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
      }).finally(function () {
        _this3.exportLoading = false;
      });
    },
    changeDialogInput: function changeDialogInput() {
      if (this.dialogType === 'menus') {
        return;
      }
      this.changeInput('dialogForm', this.dialogType === 'normal' ? 'max_ratio' : 'min_ratio');
    },
    changeInput: function changeInput(formName, field) {
      // 利润率筛选项blur校验  列表最小值不可小于上方利润率 弹窗内最大值不可大于上方利润率
      var value = Number(this[formName][field]);
      var isNotNumber = !isNumber(value) || this[formName][field] === '';
      var ratio = this[this.dialogType === 'customer' ? 'profitCustomerForm' : 'originalForm'].ratio;
      if (field === 'min_ratio') {
        if (isNotNumber || value < ratio) {
          this.$message.error("\u6700\u4F4E\u5229\u6DA6\u7387\u4E0D\u80FD\u4F4E\u4E8E".concat(ratio, "%"));
          this[formName][field] = ratio;
        }
      }
      if (field === 'max_ratio') {
        if (isNotNumber || value > ratio) {
          this.$message.error("\u6700\u9AD8\u5229\u6DA6\u7387\u4E0D\u80FD\u9AD8\u4E8E".concat(ratio, "%"));
          this[formName][field] = ratio;
        }
      }
    },
    changeAllStatus: function changeAllStatus(val) {
      var _this4 = this;
      this.dialogTableData.forEach(function (row) {
        row.selected = val;
        _this4.changeRowStatus(row);
      });
    },
    changeRowStatus: function changeRowStatus(row) {
      if (Array.isArray(row.city)) {
        row.city.forEach(function (parent) {
          parent.forEach(function (child) {
            child.selected = row.selected;
          });
        });
      }
    },
    changeCityStatus: function changeCityStatus(row) {
      var city = row.city;
      var citys = city.flat();
      row.selected = Boolean(citys.find(function (c) {
        return c.selected;
      }));
    },
    onDetailClose: function onDetailClose() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this5.dialogType = 'normal';
              _this5.$refs.dialogForm.resetFields();
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    changeType: function changeType() {
      var _arguments = arguments,
        _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this6$$refs$myTable;
        var props, _props$resetFields, resetFields, cb, _yield$_this6$getList, _yield$_this6$getList2, extend_data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              props = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
              _props$resetFields = props.resetFields, resetFields = _props$resetFields === void 0 ? true : _props$resetFields, cb = props.cb; // 到店 & 自由兑利润率设置回显 start
              if (!_this6.menusInfo[_this6.activeTab + '_discount']) {
                _context2.n = 1;
                break;
              }
              _this6.profitForm.ratio = _this6.menusInfo[_this6.activeTab + '_discount'];
              _context2.n = 3;
              break;
            case 1:
              _context2.n = 2;
              return _this6.getList({
                type: 'not_page'
              });
            case 2:
              _yield$_this6$getList = _context2.v;
              _yield$_this6$getList2 = _yield$_this6$getList.extend_data;
              extend_data = _yield$_this6$getList2 === void 0 ? {} : _yield$_this6$getList2;
              _this6.profitForm.ratio = extend_data[_this6.activeTab + '_discount'];
            case 3:
              _this6.originalForm = _objectSpread({}, _this6.profitForm);
              // 到店 & 自由兑利润率设置回显 end

              resetFields && _this6.$refs.searchForm.resetFields();
              _this6.activeName = '0'; // 切换到店/自由兑时重置回可用品牌tab
              _this6.searchForm.min_ratio = _this6.activeTab === 'cake_store_zyd' ? _this6.originalForm.ratio : '';
              _this6.menuType !== 'customerSet' && _this6.loadData();
              _this6.$emit('changeType', _this6.activeTab);
              typeof cb === 'function' && cb();
              (_this6$$refs$myTable = _this6.$refs.myTable) === null || _this6$$refs$myTable === void 0 ? void 0 : _this6$$refs$myTable.doLayout();
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    // 不满足利润率品牌明细dialog start
    viewDetail: function viewDetail() {
      var _arguments2 = arguments,
        _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var props, _props$loadTotal, loadTotal, type;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              props = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {};
              _props$loadTotal = props.loadTotal, loadTotal = _props$loadTotal === void 0 ? false : _props$loadTotal;
              _this7.getList(_objectSpread(_objectSpread({
                type: {
                  customer: 'not_allow_brand',
                  normal: 'all_not',
                  menus: 'menu_allow_brand',
                  viewBlack: _this7.activeBrand,
                  setBlack: _this7.activeBrand
                }[_this7.dialogType]
              }, _this7.dialogForm), {}, {
                cake_store_zyd_action: _this7.dialogAction
              })).then(function (res) {
                var data = res.data,
                  _res$pages = res.pages,
                  pages = _res$pages === void 0 ? {} : _res$pages;
                _this7.dialogTableData = data.map(function (i) {
                  return _objectSpread(_objectSpread({}, i), {}, {
                    selected: false
                  });
                });
                _this7.dialogTotalCount = pages.total_count || 0;
                // if (loadTotal) {
                _this7["".concat(_this7.activeBrand, "_total")] = pages.total_count || 0;
                // }
                _this7.detailDialog = true;
              });
              if (_this7.dialogType === 'setBlack' && loadTotal) {
                // 设置黑名单时，需查询另一个tab数量回显 不带搜索条件
                type = {
                  allow_brand: 'not_allow_brand',
                  not_allow_brand: 'allow_brand'
                }[_this7.activeBrand];
                _this7.getList({
                  type: type,
                  // ...this.dialogForm,
                  min_ratio: _this7.activeTab === 'cake_store_zyd' ? _this7.originalForm.ratio : '',
                  cake_store_zyd_action: _this7.dialogAction
                }).then(function (res) {
                  var _res$pages2 = res.pages,
                    pages = _res$pages2 === void 0 ? {} : _res$pages2;
                  if (loadTotal) {
                    _this7["".concat(type, "_total")] = pages.total_count || 0;
                  }
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    dialogSearch: function dialogSearch() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var type = props.type,
        _props$loadTotal2 = props.loadTotal,
        loadTotal = _props$loadTotal2 === void 0 ? false : _props$loadTotal2;
      if (type === 'reset') {
        var _this$$refs$dialogFor;
        (_this$$refs$dialogFor = this.$refs.dialogForm) === null || _this$$refs$dialogFor === void 0 ? void 0 : _this$$refs$dialogFor.resetFields();
        this.dialogForm.min_ratio = '';
        this.dialogForm.max_ratio = '';
        if (this.dialogType !== 'menus') {
          this.dialogForm[this.dialogType === 'normal' ? 'max_ratio' : 'min_ratio'] = this.activeTab === 'cake_store_zyd' ? this[this.dialogType === 'customer' ? 'profitCustomerForm' : 'originalForm'].ratio : '';
        }
      }
      this.dialogForm.page = page;
      this.viewDetail({
        loadTotal: loadTotal
      });
    },
    // 不满足利润率品牌明细dialog end
    // 拉黑 || 设为可用操作
    block: function block(type) {
      var _this8 = this;
      var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var selectData = [_objectSpread({}, row)];
      if (type === 'batch') {
        selectData = JSON.parse(JSON.stringify(this.selectionRow));
      }
      if (selectData.length < 1) {
        this.$message.error('请至少选择一条数据进行操作');
        return;
      }
      var tipText = '';
      var brandName = row[this.activeTab === 'cake_store' ? 'brand_name' : 'name'];
      if (this.dialogAction === 1) {
        // 白名单
        if (this.activeBrand === 'allow_brand') {
          tipText = type === 'batch' ? "\u786E\u5B9A\u8981\u5C06\u52FE\u9009\u7684".concat(selectData.length, "\u4E2A\u54C1\u724C\u52A0\u5165\u767D\u540D\u5355\uFF1F") : "\u786E\u5B9A\u8981\u5C06\u3010".concat(brandName, "\u3011\u52A0\u5165\u767D\u540D\u5355\uFF1F");
        } else {
          tipText = type === 'batch' ? "\u786E\u5B9A\u8981\u5C06\u52FE\u9009\u7684".concat(selectData.length, "\u4E2A\u54C1\u724C\u79FB\u9664\u767D\u540D\u5355\uFF1F") : "\u786E\u5B9A\u8981\u5C06\u3010".concat(brandName, "\u3011\u79FB\u9664\u767D\u540D\u5355\uFF1F");
        }
      } else {
        // 黑名单
        if (this.activeBrand === 'allow_brand') {
          tipText = type === 'batch' ? "\u786E\u5B9A\u8981\u62C9\u9ED1\u52FE\u9009\u7684".concat(selectData.length, "\u4E2A\u54C1\u724C\uFF1F") : "\u786E\u5B9A\u8981\u62C9\u9ED1\u3010".concat(brandName, "\u3011\uFF1F");
        } else {
          tipText = "\u786E\u5B9A\u8981\u5C06".concat(type === 'batch' ? '勾选的' + selectData.length + '个品牌' : '【' + brandName + '】', "\u8BBE\u4E3A\u53EF\u7528\u54C1\u724C\uFF1F");
        }
      }
      this.$confirm(tipText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this8.$emit('setBlackCake', _objectSpread(_objectSpread({}, _this8.activeTab === 'cake_store' ? {
          selectIds: selectData.map(function (i) {
            return i.brand_id;
          })
        } : {
          blackSelectZyd: selectData.map(function (i) {
            return _objectSpread(_objectSpread({}, i), {}, {
              zyd_id: i.city[0][0].zyd_id,
              // 原来就这样写的..
              selected: true
            });
          })
        }), {}, {
          params: {
            type: {
              allow_brand: 'add',
              not_allow_brand: 'remove'
            }[_this8.activeBrand],
            cake_store_zyd_action: _this8.dialogAction
          },
          showMsg: false,
          cb: function cb() {
            _this8.$message.success('操作成功');
            _this8.viewDetail({
              loadTotal: true
            });
            _this8.getList({
              type: 'allow_brand'
            }, true);
            _this8.getBlackTotal(); // 订单级黑名单品牌数
          }
        }));
      }).catch(function () {});
    },
    // 查看覆盖城市 start
    onClose: function onClose() {
      this.filterText = '';
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    openCityDialog: function openCityDialog(citys) {
      this.cityList = citys;
      this.showCityDialog = true;
    },
    // 查看覆盖城市 end
    confirmProfit: function confirmProfit() {
      var _this9 = this;
      this.$refs.profitForm.validate(function (valid) {
        if (valid) {
          _this9.searchForm.min_ratio = _this9.activeTab === 'cake_store_zyd' ? _this9.profitForm.ratio : '';
          _this9.$emit('setDiscount', {
            ratio: _this9.profitForm.ratio,
            activeTab: _this9.activeTab,
            cb: function cb() {
              // 顺序不可更改
              _this9.toEditProfit();
              _this9.loadData();
            }
          });
        }
      });
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.getList({
        type: 'allow_brand'
      }, true);
    },
    searchData: function searchData(type) {
      if (type === 'reset') {
        this.$refs.searchForm.resetFields();
        this.searchForm.min_ratio = this.activeTab === 'cake_store_zyd' ? this.originalForm.ratio : '';
      }
      this.pageChange(1);
    },
    changeBrandTab: function changeBrandTab() {
      this.dialogSearch(1, {
        type: 'reset',
        loadTotal: true
      });
    },
    toEditProfit: function toEditProfit(type) {
      if (type === 'cancel') {
        this.profitForm = _objectSpread({}, this.originalForm);
      } else {
        this.originalForm = _objectSpread({}, this.profitForm);
      }
      this.disableProfit = !this.disableProfit;
    },
    getList: function getList() {
      var _this0 = this;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var isSetData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new Promise(function (resolve) {
        cakeStoreBrands(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _this0.ruleType === 'cardType' ? {
          rule_id: _this0.ruleInfo.id
        } : {
          order_id: _this0.order_id
        }), _this0.searchForm), _this0.profitForm), params), _this0.dialogType === 'customer' ? {
          account_id: _this0.profitCustomerForm.account_id
        } : {}), {}, {
          menu_id: _this0.currentRowMenu.id
        }), _this0.activeTab, _this0.dialogType === 'customer' ? 'customerSet' : _this0.menuType // 如果是查看客户级黑名单明细弹窗 强制传customerSet菜单类型
        ).then(function (res) {
          if (isSetData) {
            var _res$data$data = res.data.data,
              data = _res$data$data === void 0 ? [] : _res$data$data;
            _this0.tableData = data;
            _this0.totalCount = res.data.pages.total_count || 0;
          }
          resolve(res.data);
        });
      });
    },
    loadData: function loadData() {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _yield$_this1$getList, pages, _yield$_this1$getList2, extend_data, _extend_data$customer, customer_card_rule_count, _extend_data$settings, settings, _extend_data$route_ty, route_type, cake_store_sxd_profit_rate_control, _settings$cake_store_, cake_store_sxd_profit_rate, _settings$channel_cak, channel_cake_store_sxd_profit_rate, account_id, _yield$_this1$getList3, menu_pages;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this1.searchForm.page = 1;
              _this1.getList({
                type: 'allow_brand'
              }, true); // 获取可用品牌数据

              // 蛋糕到店 加载可用门店/可用商品数据（tab 数量展示） start
              if (_this1.activeTab === 'cake_store') {
                _this1.loadStoreData();
                _this1.loadGoodsData();
              }
              // 蛋糕到店 加载可用门店/可用商品数据 end
              _context4.n = 1;
              return _this1.getList(_objectSpread({
                type: 'not_page'
              }, _this1.activeTab === 'cake_store_zyd' ? {
                min_ratio: '',
                max_ratio: _this1.originalForm.ratio
              } : {}));
            case 1:
              _yield$_this1$getList = _context4.v;
              pages = _yield$_this1$getList.pages;
              _yield$_this1$getList2 = _yield$_this1$getList.extend_data;
              extend_data = _yield$_this1$getList2 === void 0 ? {} : _yield$_this1$getList2;
              // 仅获取不满足利润率品牌数量
              _this1.unmetTotal = pages.total_count || 0; // 不满足利润率品牌数

              // 蛋糕自由兑 客户级利润率设置回显 start - 仅当蛋糕自由兑 & 订单规则下的 才有该参数
              _extend_data$customer = extend_data.customer_card_rule_count, customer_card_rule_count = _extend_data$customer === void 0 ? 0 : _extend_data$customer, _extend_data$settings = extend_data.settings, settings = _extend_data$settings === void 0 ? {} : _extend_data$settings, _extend_data$route_ty = extend_data.route_type, route_type = _extend_data$route_ty === void 0 ? '' : _extend_data$route_ty;
              cake_store_sxd_profit_rate_control = settings.cake_store_sxd_profit_rate_control, _settings$cake_store_ = settings.cake_store_sxd_profit_rate, cake_store_sxd_profit_rate = _settings$cake_store_ === void 0 ? '' : _settings$cake_store_, _settings$channel_cak = settings.channel_cake_store_sxd_profit_rate, channel_cake_store_sxd_profit_rate = _settings$channel_cak === void 0 ? '' : _settings$channel_cak, account_id = settings.account_id;
              _this1.route_type = route_type;
              _this1.profitCustomerForm = {
                unmetTotal: customer_card_rule_count,
                rate_control: {
                  0: '默认规则',
                  1: '个性化'
                }[cake_store_sxd_profit_rate_control] || '',
                ratio: {
                  0: channel_cake_store_sxd_profit_rate,
                  1: cake_store_sxd_profit_rate
                }[cake_store_sxd_profit_rate_control] || '',
                account_id: account_id
              };
              // 蛋糕自由兑 客户级利润率设置回显 end

              _this1.getBlackTotal(); // 订单级黑名单品牌数

              // const { pages: allow_pages } = await this.getList({
              // 	type: 'allow_not_page'
              // }) // 仅获取满足利润率品牌数量
              // this.allowTotal = allow_pages.total_count || 0 // 可用品牌数
              _context4.n = 2;
              return _this1.getList({
                type: 'menu_allow_brand_not_page',
                min_ratio: '',
                max_ratio: ''
              });
            case 2:
              _yield$_this1$getList3 = _context4.v;
              menu_pages = _yield$_this1$getList3.pages;
              // 仅获取满足利润率品牌数量
              _this1.menuTotal = menu_pages.total_count || 0; // 菜单级规则 可用品牌数
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getBlackTotal: function getBlackTotal() {
      var _this10 = this;
      this.getList({
        type: 'not_allow_brand'
      }).then(function (res) {
        var pages = res.pages,
          _res$extend_data = res.extend_data,
          extend_data = _res$extend_data === void 0 ? {} : _res$extend_data;
        var _extend_data$cake_sto = extend_data.cake_store_zyd_action,
          cake_store_zyd_action = _extend_data$cake_sto === void 0 ? -1 : _extend_data$cake_sto;
        _this10.action = _this10.activeTab === 'cake_store_zyd' ? cake_store_zyd_action : -1; // 未设置=-1 | 黑名单=0 | 白名单=1
        _this10.blackBrandTotal = pages.total_count || 0; // 订单级黑名单品牌数
      });
    },
    getConfig: function getConfig() {
      var _this11 = this;
      getCakeStoreCategory({
        menu_id: this.currentRowMenu.id
      }).then(function (res) {
        _this11.categoryList = res.data.data;
      });
      getStoreCitys().then(function (res) {
        _this11.citys = res.data.tree;
      });
    },
    // 蛋糕到店 可用门店/可用商品 tab start
    tabChange: function tabChange(tab) {
      this.activeName = tab.name;
      if (this.activeName === '1') {
        // 切换到可用门店时，清空可用商品数据
        this.goodsList = [];
        this.storeForm.page = 1;
        this.loadStoreData();
        this.getCakeStoreBrandsList(''); // 初始加载所有品牌
      }
      if (this.activeName === '2') {
        // 切换到可用商品时，清空可用门店数据
        this.storeList = [];
        this.goodsForm.page = 1;
        this.loadGoodsData();
        this.getCakeStoreBrandsList(''); // 初始加载所有品牌
      }
    },
    getCommonParams: function getCommonParams() {
      return this.ruleType === 'cardType' ? {
        rule_id: this.ruleInfo.id
      } : {
        order_id: this.order_id
      };
    },
    // 可用门店列表
    loadStoreData: function loadStoreData() {
      var _this12 = this;
      cakeStoreStoresV2(_objectSpread(_objectSpread(_objectSpread({}, this.getCommonParams()), this.storeForm), {}, {
        ratio: this.profitForm.ratio,
        type: 'allow_brand',
        menu_id: this.currentRowMenu.id
      })).then(function (res) {
        var _res$data = res.data,
          _res$data$data2 = _res$data.data,
          data = _res$data$data2 === void 0 ? [] : _res$data$data2,
          _res$data$pages = _res$data.pages,
          pages = _res$data$pages === void 0 ? {} : _res$data$pages;
        _this12.storeList = data;
        _this12.storeTotal = pages.total_count || 0;
      });
    },
    // 可用商品列表
    loadGoodsData: function loadGoodsData() {
      var _this13 = this;
      cakeStoreGoodsV2(_objectSpread(_objectSpread(_objectSpread({}, this.getCommonParams()), this.goodsForm), {}, {
        ratio: this.profitForm.ratio,
        type: 'allow_brand',
        menu_id: this.currentRowMenu.id
      })).then(function (res) {
        var _res$data2 = res.data,
          _res$data2$data = _res$data2.data,
          data = _res$data2$data === void 0 ? [] : _res$data2$data,
          _res$data2$pages = _res$data2.pages,
          pages = _res$data2$pages === void 0 ? {} : _res$data2$pages;
        _this13.goodsList = data;
        _this13.goodsTotal = pages.total_count || 0;
      });
    },
    searchStoreData: function searchStoreData() {
      this.storeForm.page = 1;
      this.loadStoreData();
    },
    searchGoodsData: function searchGoodsData() {
      this.goodsForm.page = 1;
      this.loadGoodsData();
    },
    pageChangeStore: function pageChangeStore(page) {
      this.storeForm.page = page;
      this.loadStoreData();
    },
    sizeChangeStore: function sizeChangeStore(size) {
      this.storeForm.pagesize = size;
      this.pageChangeStore(1);
    },
    pageChangeGoods: function pageChangeGoods(page) {
      this.goodsForm.page = page;
      this.loadGoodsData();
    },
    sizeChangeGoods: function sizeChangeGoods(size) {
      this.goodsForm.pagesize = size;
      this.pageChangeGoods(1);
    },
    sortStoreChange: function sortStoreChange(val) {
      this.storeForm.sort = val.order;
      this.storeForm.sortParam = val.order ? val.prop : null;
      this.loadStoreData();
    },
    sortGoodsChange: function sortGoodsChange(val) {
      this.goodsForm.sort = val.order;
      this.goodsForm.sortParam = val.order ? val.prop : null;
      this.loadGoodsData();
    },
    getCityBrand: function getCityBrand(val) {
      this.brandList = [];
      if (this.activeName === '1') {
        this.storeForm.brand_id = '';
      }
      if (this.activeName === '2') {
        this.goodsForm.brand_id = '';
      }
      // 不选城市时获取所有品牌，选择城市后获取当前城市的品牌
      this.getCakeStoreBrandsList(val);
    },
    getCakeStoreBrandsList: function getCakeStoreBrandsList(region_id) {
      var _this14 = this;
      // region_id 为空时不传该参数，获取所有品牌；有值时按城市过滤
      var params = {};
      if (region_id) {
        params.region_id = region_id;
      }
      _getCakeStoreBrandsList(params).then(function (res) {
        _this14.brandList = res.data.data;
      });
    },
    // 可用商品-通用门店数量 跳转可用门店tab并回填筛选项
    toStoreTab: function toStoreTab(row) {
      this.activeName = '1';
      this.storeForm.region_id = this.goodsForm.region_id || '';
      this.storeForm.brand_id = row.brand_id;
      this.storeForm.goods_id = row.goods_id;
      this.storeForm.page = 1;
      this.getCakeStoreBrandsList(this.storeForm.region_id);
      this.loadStoreData();
    },
    openGoodsDetail: function openGoodsDetail(row) {
      var _this15 = this;
      getGoodsDetail({
        goods_id: row.goods_id
      }).then(function (res) {
        _this15.goodsInfo = res.data.data;
        _this15.goodsDetailDialog = true;
      });
    },
    // 导出可用门店
    exportStoreData: function exportStoreData() {
      var _this16 = this;
      var tipText = this.cakeStoreType === 'set' ? '【运营导出】导出的字段为：门店名称、分类、品牌名称、城市、门店地址、<span style="color:red">门店电话、经度、纬度</span>' : '【导出】包含的字段为：门店名称、分类、品牌名称、城市、门店地址';
      this.$confirm(tipText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(function () {
        _this16.exportStoreLoading = true;
        exportCakeStoreStoresV2(_objectSpread(_objectSpread(_objectSpread({}, _this16.getCommonParams()), _this16.storeForm), {}, {
          ratio: _this16.profitForm.ratio,
          type: 'allow_brand',
          menu_id: _this16.currentRowMenu.id,
          action: _this16.cakeStoreType === 'set' ? 'set' : 'show'
        }), _this16.menuType).then(function (res) {
          if (res.data) {
            _this16.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
          }
        }).finally(function () {
          _this16.exportStoreLoading = false;
        });
      }).catch(function () {});
    },
    // 导出可用商品
    exportGoodsData: function exportGoodsData() {
      var _this17 = this;
      this.exportGoodsLoading = true;
      exportCakeStoreGoodsV2(_objectSpread(_objectSpread(_objectSpread({}, this.getCommonParams()), this.goodsForm), {}, {
        ratio: this.profitForm.ratio,
        type: 'allow_brand',
        menu_id: this.currentRowMenu.id,
        action: this.cakeStoreType === 'set' ? 'set' : 'show'
      }), this.menuType).then(function (res) {
        if (res.data) {
          _this17.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
        }
      }).finally(function () {
        _this17.exportGoodsLoading = false;
      });
    } // 蛋糕到店 可用门店/可用商品 tab end
  },
  created: function created() {
    var _this18 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _this18.getConfig();
            _this18.activeTab = _this18.defaultTab || _this18.activeTab;
            _this18.changeType({
              resetFields: false
            });
          case 1:
            return _context5.a(2);
        }
      }, _callee5);
    }))();
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  computed: {
    showBrandList: function showBrandList() {
      // 自由兑下始终展示可用品牌列表；到店下仅可用品牌tab展示
      return this.activeTab === 'cake_store_zyd' || this.activeName === '0';
    },
    dialogTitle: function dialogTitle() {
      var blackName = this.activeTab === 'cake_store_zyd' ? '黑/白名单' : '黑名单';
      var titleName = {
        customer: '客户级黑名单品牌',
        normal: '不满足利润率品牌',
        menus: '菜单级规则可见品牌',
        viewBlack: "\u8BA2\u5355\u7EA7\u54C1\u724C".concat(blackName),
        setBlack: "".concat(this.menuType === 'customerSet' ? '客户' : '订单', "\u7EA7\u54C1\u724C").concat(blackName, "\u8BBE\u7F6E")
      }[this.dialogType];
      return "".concat(titleName, "\uFF08\u86CB\u7CD5").concat(this.activeTab === 'cake_store' ? '到店' : '自由兑', "\uFF09");
    },
    hasExportRole: function hasExportRole() {
      var authEnum = {
        orderDetails: {
          cake_store: '/orders/card-rule-extend/cake-store-brands-v2-export',
          cake_store_zyd: '/orders/card-rule-extend/cake-store-zyd-brands-v2-export'
        },
        channelCardTypeManage: {
          cake_store: '/orders/card-rule-extend/cake-store-brands-v2-common-export',
          cake_store_zyd: '/orders/card-rule-extend/cake-store-zyd-brands-v2-common-export'
        },
        saleCardTypeManage: {
          cake_store: '/orders/card-rule-extend/cake-store-brands-v2-sale-export',
          cake_store_zyd: '/orders/card-rule-extend/cake-store-zyd-brands-v2-sale-export'
        }
      };
      var keys = Object.keys(authEnum);
      if (keys.includes(this.menuType)) {
        // 产品要求 只需要在这三个页面中判断权限即可
        var rolePath = authEnum[this.menuType][this.activeTab];
        return this.$hasBtnRoles(rolePath);
      }
      return false;
    },
    hasExportRoleStore: function hasExportRoleStore() {
      // 可用门店导出权限 仅蛋糕到店 tab 路径与导出接口一致
      var authEnum = {
        orderDetails: '/orders/card-rule-extend/cake-store-stores-v2-export',
        channelCardTypeManage: '/orders/card-rule-extend/cake-store-stores-v2-common-export',
        saleCardTypeManage: '/orders/card-rule-extend/cake-store-stores-v2-sale-export'
      };
      var keys = Object.keys(authEnum);
      if (keys.includes(this.menuType)) {
        // 产品要求 只需要在这三个页面中判断权限即可
        var rolePath = authEnum[this.menuType];
        return this.$hasBtnRoles(rolePath);
      }
      return false;
    },
    hasExportRoleGoods: function hasExportRoleGoods() {
      // 可用商品导出权限 仅蛋糕到店 tab 路径与导出接口一致
      var authEnum = {
        orderDetails: '/orders/card-rule-extend/cake-store-goods-v2-export',
        channelCardTypeManage: '/orders/card-rule-extend/cake-store-goods-v2-common-export',
        saleCardTypeManage: '/orders/card-rule-extend/cake-store-goods-v2-sale-export'
      };
      var keys = Object.keys(authEnum);
      if (keys.includes(this.menuType)) {
        var rolePath = authEnum[this.menuType];
        return this.$hasBtnRoles(rolePath);
      }
      return false;
    },
    isIndeterminate: function isIndeterminate() {
      var selectLength = this.selectionRow.length;
      var tableLength = this.dialogTableData.length;
      this.checkAll = tableLength > 0 && selectLength === tableLength;
      return selectLength > 0 && selectLength < tableLength;
    },
    selectionRow: function selectionRow() {
      return this.dialogTableData.filter(function (i) {
        return i.selected;
      });
    }
  }
};